import { JSX, ReactNode, createContext, useContext } from "react";

// Scroll viewport the sticky CAD viewer pins to.
// `null` = main window; an element = pin to that box (e.g. a dialog).
const StickyCadContainerContext = createContext<HTMLElement | null>(null);

export function StickyCadContainerProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: ReactNode;
}): JSX.Element {
  return (
    <StickyCadContainerContext.Provider value={container}>
      {children}
    </StickyCadContainerContext.Provider>
  );
}

export function useStickyCadContainer(): HTMLElement | null {
  return useContext(StickyCadContainerContext);
}
